import { Inject, Injectable } from '@angular/core'
import { APP_BASE_HREF, Location } from '@angular/common'

@Injectable({
    providedIn: 'root',
})
export class ModulePathService {
    constructor(@Inject(APP_BASE_HREF) private appBaseHref: string, private location: Location) {}

    getPathFromModuleRoot(path: string, useNormalize = true) {
        let basePath = this.appBaseHref

        /* 
      If the APP_BASE_HREF value contains the location origin, trim that. For example: 
      - From: https://mistergreen.nl/tesla-model-3-lease/configurator
      - To:   /tesla-model-3-lease/configurator
    */
        if (basePath.startsWith('http') || basePath.startsWith('//')) {
            const originSliceIndex = [...basePath].findIndex(
                (char, idx) => this.location.normalize(window.location.origin)[idx] !== char
            )
            basePath = originSliceIndex > -1 ? basePath.slice(originSliceIndex) : '/'
        }

        /* 
      Trim the remaining APP_BASE_HREF value from the path. For example: 
      - APP_BASE_HREF: /tesla-model-3-lease/configurator
      - Path was:      /tesla-model-3-lease/configurator/confirm
      - Path becomes:  /confirm
    */
        const sliceIndex = [...path].findIndex((char, idx) => basePath[idx] !== char)
        path = sliceIndex > -1 ? path.slice(sliceIndex) : '/'

        /*
      For correct handling of URL comparisons,
      ensure the path starts with a forward slash.
    */

        path = path.startsWith('/') ? path : `/${path}`

        /*
      Normalize path (stripping trailing slashes) by default.
      Passing false to the useNormalize argument disables this behavior.
    */
        return useNormalize ? this.location.normalize(path) : path
    }
}
